import { ColumnSettings, ColumnTypes, TableFilterType } from '@app/sharedModule/models/table-settings.model';
import { TranslatedFulfillmentStatus } from '@pdqdev/pdq-shared/dist/OrderData';

export const deleteTableConfig: ColumnSettings[] = [
  {
    type: ColumnTypes.CHECKBOX,
    prop: 'checkbox',
    hideColumnName: true,
    sortable: false,
    width: 70,
    minWidth: 70,
    maxWidth: 70,
  },
  {
    type: ColumnTypes.COLOR,
    prop: 'colorCoding',
    name: 'Color coding',
    filterType: TableFilterType.COLOR,
    filterOption: 'IN',
    filterValueArray: [],
    sortDirection: null,
    width: 70,
    minWidth: 70,
    maxWidth: 120,
    canBeHide: true,
    default: true,
  },
  {
    sortDirection: null,
    prop: 'orderNumber',
    name: 'Order no.',
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    fraudRisk: true,
    withExchange: true,
    pendingPayment: true,
    inventoryOutOfStock: true,
    weather: true,
    split: true,
    merged: true,
    width: 70,
    minWidth: 70,
    canBeHide: true,
    default: true,
  },
  {
    prop: 'externalOrderNumber',
    name: 'External order number',
    type: ColumnTypes.TEXT,
    width: 50,
    minWidth: 50,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    canBeHide: true,
    default: false,
  },
  {
    prop: 'itemCount',
    name: 'Items',
    width: 70,
    minWidth: 70,
    maxWidth: 70,
    filterType: TableFilterType.NUMBER,
    filterOption: 'IN',
    filterValue: '',
    sortDirection: null,
    default: true,
    canBeHide: false,
  },
  {
    prop: 'zone',
    name: 'Zone',
    width: 70,
    minWidth: 70,
    maxWidth: 70,
    filterType: TableFilterType.NUMBER,
    filterOption: 'IN',
    filterValue: '',
    sortDirection: null,
    default: false,
    canBeHide: true,
  },
  {
    type: ColumnTypes.DATE,
    prop: 'createdDate',
    name: 'Date ordered',
    width: 110,
    minWidth: 90,
    filterType: TableFilterType.DATE,
    filterOption: 'DATE RANGE',
    filterValue: '',
    sortDirection: null,
    headerTitleIcon: true,
    canBeHide: true,
    default: true,
  },
  {
    prop: 'shippingAddressFormatted',
    name: 'Ship to',
    width: 180,
    minWidth: 180,
    type: ColumnTypes.POPOVER_COLUMN,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    sortDirection: null,
    withNote: true,
    sortFieldName: ['customer.ordersCount'],
    default: true,
    canBeHide: false,
    withLoyalty: true,
  },
  {
    prop: 'deletedBy',
    name: 'Deleted by',
    width: 100,
    minWidth: 100,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    sortDirection: null,
    sortFieldName: ['shippingFirstName'],
    default: true,
    canBeHide: false,
  },
  {
    prop: 'deletedDate',
    name: 'Cancellation date',
    width: 190,
    minWidth: 190,
    filterType: TableFilterType.DATE,
    filterOption: 'DATE RANGE',
    filterValue: '',
    sortDirection: null,
    default: true,
    canBeHide: false,
  },
  {
    prop: 'totalTagsCount',
    name: 'Tags',
    type: ColumnTypes.POPOVER_COLUMN,
    width: 80,
    minWidth: 80,
    filterType: TableFilterType.TAGS,
    filterOption: 'IN',
    filterValue: '',
    filterValueArray: [],
    default: false,
    sortDirection: '',
    canBeHide: true,
    tooltipText: 'View all tags',
    scrollSection: 'orderTagsId',
    zeroStateText: 'tag',
  },
  {
    prop: 'fulfillmentStatus',
    name: 'Fulfillment status',
    type: ColumnTypes.FULFILLMENT,
    width: 100,
    minWidth: 100,
    maxWidth: 120,
    filterType: TableFilterType.SELECT,
    filterSelectOptions: [
      {
        value: TranslatedFulfillmentStatus.FULFILLED,
        text: 'Fulfilled',
      },
      {
        value: TranslatedFulfillmentStatus.PARTIALLY_FULFILLED,
        text: 'Partially Fulfilled',
      },
      {
        value: TranslatedFulfillmentStatus.NOT_FULFILLED,
        text: 'Unfulfilled',
      },
    ],
    filterOption: 'LIKE',
    sortDirection: '',
    canBeHide: true,
    default: true,
  },
  {
    prop: 'comment',
    name: 'PDQ stage',
    width: 80,
    minWidth: 80,
    filterType: TableFilterType.SELECT,
    filterOption: 'LIKE',
    sortDirection: '',
    default: true,
    canBeHide: false,
  },
  {
    prop: 'deletedNote',
    name: 'Note',
    width: 60,
    minWidth: 60,
    maxWidth: 60,
    type: ColumnTypes.EMPTY,
    filterType: TableFilterType.EMPTY,
    deleteNote: true,
    canBeHide: false,
    sortable: false,
    withRestoreIcon: true,
  },
  {
    prop: 'Actions',
    name: 'actions',
    hideColumnName: true,
    width: 40,
    minWidth: 40,
    maxWidth: 40,
    type: ColumnTypes.LAST_CHILD,
    sortable: false,
    withRestoreIcon: true,
  },
];
